import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import {
  CUSTOMER_ORDER_DATE_RANGE_FILTER_KEYS,
  CUSTOMER_ORDER_DATE_RANGE_TYPE_TO_LABEL,
  SALES_ORDER_STATUS_TO_LABEL,
} from "../../../constants"
import type { CustomerOrderSearchParams } from "../../../schemas"

import { FilterChip } from "@/components/common/Filters"

interface CustomerOrderFilterChipsProps {
  searchParams: CustomerOrderSearchParams
  onRemove: (
    keyOrKeys: keyof CustomerOrderSearchParams | (keyof CustomerOrderSearchParams)[],
    value?: string | number
  ) => void
}

export const CustomerOrderFilterChips: FC<CustomerOrderFilterChipsProps> = ({ searchParams, onRemove }) => {
  const { statuses = [], dateFrom, dateTo, dateRangeType } = searchParams

  const hasActiveFilters = statuses.length > 0 || !!dateFrom || !!dateTo

  if (!hasActiveFilters) return null

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='customer-orders.filter-chips'>
      <Typography variant='body1'>Filters:</Typography>
      {statuses.map((status) => (
        <FilterChip
          key={status}
          testId={`customer-orders.filter-chips.status-chip-${status}`}
          label={`Status: ${SALES_ORDER_STATUS_TO_LABEL[status]}`}
          onDelete={() => onRemove("statuses", status)}
        />
      ))}
      {(dateFrom || dateTo) && (
        <FilterChip
          testId='customer-orders.filter-chips.date-range-chip'
          label={`${dateRangeType ? CUSTOMER_ORDER_DATE_RANGE_TYPE_TO_LABEL[dateRangeType] : "Date"}: ${dateFrom ?? "—"} – ${dateTo ?? "—"}`}
          onDelete={() => onRemove(CUSTOMER_ORDER_DATE_RANGE_FILTER_KEYS)}
        />
      )}
    </Box>
  )
}
